import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedEffects } from './+state/effects/shared.effects';
import * as fromShared from './+state/reducer/shared.reducer';
import { StateFacade } from './+state/state.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromShared.SHARED_FEATURE_KEY, fromShared.reducer),
    EffectsModule.forFeature([SharedEffects])
  ],
  exports: [],
  providers: [StateFacade]
})
export class SharedModule {}
